export const selectCategories = (state) => state.category.categories;
export const selectCategoriesLoading = (state) => state.category.loading;
export const selectCategoriesError = (state) => state.category.error;
export const selectCategoriesSuccess = (state) => state.category.success;

// Selector to get active categories only
export const selectActiveCategories = (state) => 
  state.category.categories.filter(category => category.status === 'active');

// Selector to get category by ID
export const selectCategoryById = (state, categoryId) => 
  state.category.categories.find(category => category._id === categoryId);